import { Action } from "types/generated";
import { AccessResult, EntityWithAllowedActions, NO_ACCESS_MESSAGE } from "utils/access";

export const canDeleteVersion = (
  template: EntityWithAllowedActions,
  deploymentsCount: number
): AccessResult => {
  if (!template.allowedActions.includes(Action.UpdateBlueprintsVersionedGroup)) {
    return { result: false, message: NO_ACCESS_MESSAGE };
  }

  if (deploymentsCount > 0) {
    return {
      result: false,
      message: "Cannot delete version with existing deployments",
    };
  }

  return { result: true };
};
